export default __webpack_public_path__ + "static/media/wb15.a5515d54.png";